const ACCESS_KEY = "allmark.access";
const REFRESH_KEY = "allmark.refresh";
const ACCESS_EXP_KEY = "allmark.access.exp";

export interface TokenSet {
  accessToken: string;
  accessExpiresUtc: string;
  refreshToken: string;
  refreshExpiresUtc: string;
}

export const AUTH_CHANGED_EVENT = "allmark:auth-changed";

export function saveTokens(t: TokenSet): void {
  localStorage.setItem(ACCESS_KEY, t.accessToken);
  localStorage.setItem(REFRESH_KEY, t.refreshToken);
  localStorage.setItem(ACCESS_EXP_KEY, t.accessExpiresUtc);
  window.dispatchEvent(new Event(AUTH_CHANGED_EVENT));
}

export function clearTokens(): void {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(ACCESS_EXP_KEY);
  window.dispatchEvent(new Event(AUTH_CHANGED_EVENT));
}

export function getAccessToken(): string | null {
  return localStorage.getItem(ACCESS_KEY);
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_KEY);
}

export function isAccessExpired(skewSeconds = 30): boolean {
  const exp = localStorage.getItem(ACCESS_EXP_KEY);
  if (!exp) return true;
  return new Date(exp).getTime() - skewSeconds * 1000 < Date.now();
}

let refreshing: Promise<TokenSet | null> | null = null;

export async function refreshAccessToken(): Promise<TokenSet | null> {
  if (refreshing) return refreshing;
  const refresh = getRefreshToken();
  if (!refresh) return null;
  refreshing = (async () => {
    try {
      const res = await fetch("/api/auth/refresh", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ refreshToken: refresh }),
      });
      if (!res.ok) { clearTokens(); return null; }
      const body = (await res.json()) as { accessToken: string; accessTokenExpiresUtc: string; refreshToken: string; refreshTokenExpiresUtc: string };
      const t: TokenSet = {
        accessToken: body.accessToken, accessExpiresUtc: body.accessTokenExpiresUtc,
        refreshToken: body.refreshToken, refreshExpiresUtc: body.refreshTokenExpiresUtc,
      };
      saveTokens(t);
      return t;
    } finally {
      refreshing = null;
    }
  })();
  return refreshing;
}
